import axios, { AxiosRequestConfig } from "axios";
import { getBackendApiUrlForCurrentInstance } from "../config";

class ClientImpl {
  private url: string;

  private accessToken: () => Promise<string>;

  constructor() {
    this.url = getBackendApiUrlForCurrentInstance();
  }

  public setAccessToken(accessToken: () => Promise<string>) {
    this.accessToken = accessToken;
  }

  private async buildHeaders(): Promise<AxiosRequestConfig> {
    return {
      headers: {
        Authorization: "Bearer " + (await this.accessToken()),
      },
    };
  }

  async get<T>(path: string): Promise<T> {
    const headers = await this.buildHeaders();

    return axios.get(`${this.url}${path}`, headers);
  }

  async post<T>(path: string, body: object): Promise<T> {
    const headers = await this.buildHeaders();

    return axios.post(`${this.url}${path}`, body, headers);
  }

  async put<T>(path: string, body: object): Promise<T> {
    const headers = await this.buildHeaders();

    return axios.put(`${this.url}${path}`, body, headers);
  }
}

export const Client = new ClientImpl();
